export default __webpack_public_path__ + "static/media/avatar_2.392e0315.svg";